import { PropsWithChildren, ReactNode } from 'react'

import { Breadcrumbs } from '@/lib/core/components/Breadcrumbs'
import { Location, PageHeader, PageTitle } from '@/lib/core/components/Layout/Layout.styles'

export type PageHeaderProps = PropsWithChildren<{
  title: ReactNode
}>

export const PageTop = ({ children, title }: PageHeaderProps) => {
  return (
    <PageHeader>
      <Location>
        <PageTitle>{title}</PageTitle>
        <Breadcrumbs />
      </Location>
      {children}
    </PageHeader>
  )
}
